










































































































































































































import Vue from 'vue'
import { codemirror } from 'vue-codemirror'
import { EditorConfiguration } from 'codemirror'
import { Howl, Howler } from 'howler'

import { app } from '../main'

import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/python/python.js'
import 'codemirror/theme/dracula.css'
import 'codemirror/keymap/vim.js'

const SpeechRecognition = SpeechRecognition || webkitSpeechRecognition
const SpeechGrammarList = SpeechGrammarList || webkitSpeechGrammarList
const SpeechRecognitionEvent =
  SpeechRecognitionEvent || webkitSpeechRecognitionEvent

const speech = new SpeechRecognition()
window.speech = speech

speech.lang = 'th-TH'
// speech.continuous = true

const isThai = (text: string) =>
  Array.from(text).some(x => /[\u0E00-\u0E7F]/.test(x))

const cmOptions: EditorConfiguration = {
  tabSize: 2,
  mode: 'python',
  theme: 'dracula',
  lineNumbers: false,
  // keyMap: 'vim',
  showCursorWhenSelecting: false,
  viewportMargin: Infinity
}

const starterCode = `
print("Hello, World!")
setText("Welcome to Voice Kit!")
setColor("#8e44ad")
`.trim()

function withExtras(code: string) {
  const extras = `
from browser import window

def setColor(color):
  window.eval("setColor(\`%s\`)" % color)

def setImage(image):
  window.eval("setImage(\`%s\`)" % image)

def setText(text):
  window.eval("setText(\`%s\`)" % text)

def youtube(youtubeId):
  window.eval("youtube(\`%s\`)" % youtubeId)

def speak(text): 
  print("H")

def listen(): 
  return window.eval("listen()")

def say(text): 
  window.eval("say(\`%s\`)" % text)

def playSound(url):
  window.eval("playSound(\`%s\`)" % url)
`.trim()

  return extras + '\n' + code
}

function run(code: string) {
  if (!window.__BRYTHON__) return

  const js = window.__BRYTHON__.python_to_js(withExtras(code))

  console.groupCollapsed('ℹ️ Translating Python to JavaScript')
  console.log('Python:', code)
  console.log('JavaScript:', js)
  console.groupEnd()

  return eval.call(this, js)
}

function speak(text) {
  const sid = Math.random().toString(36)

  const u = new SpeechSynthesisUtterance(text)
  u.volume = 1 // 0 - 1
  u.pitch = 1 // 0 - 2
  u.rate = 1 // 0 - 10

  if (isThai(text)) {
    const Kanya = speechSynthesis.getVoices().find(x => x.voiceURI === 'Kanya')
    u.voice = Kanya
    u.lang = 'th-TH'
  }

  u.onerror = e => {
    console.error('TTS Error:', e)
  }

  u.onstart = e => speech.stop()

  speechSynthesis.speak(u)

  return u
}

window.run = run
window.speak = speak

const saveEditor = (code: string) => localStorage.setItem('editor.code', code)

export default Vue.extend({
  components: { codemirror },

  data: () => ({
    code: starterCode,
    cmOptions,
    logs: [],
    message: 'Voice Kit',
    color: '#9b59b6',
    youtubeId: '',
    transcripts: [],
    isShowingEditor: false,
    isFullEditor: false,
    textField: '',
    isListening: false
  }),

  mounted() {
    const savedCode = localStorage.getItem('editor.code')
    if (savedCode) this.code = savedCode

    window.setText = (text: string) => (this.message = text)
    window.setColor = (color: string) => (this.color = color)
    window.setImage = (image: string) => (this.color = `url(${image})`)

    window.youtube = (query: string) => {
      const match = query.match(/youtube\.com\/watch\?v\=(\w+)/)
      if (!match) return

      this.youtubeId = match[1]
    }

    window.playSound = (url: string) => {
      const sound = new Howl({ src: [url] })

      sound.play()
    }

    window.listen = (text: string) =>
      this.transcripts[this.transcripts.length - 1]

    window.say = (text: string) => speak(text)

    speech.onstart = () => {
      console.log('👂🏻 listening...')
      this.isListening = true
    }

    speech.onresult = e => {
      const text = e.results[0][0].transcript
      console.log('💬:', text)

      this.transcripts = [...this.transcripts, text]
      this.runCode()

      console.log('Transcripts:', this.transcripts)
      this.isListening = false
    }

    setInterval(() => saveEditor(this.code), 2000)
  },

  methods: {
    startSpeech() {
      if (this.isListening) return

      speech.start()
    },
    toggleEditor() {
      this.isShowingEditor = !this.isShowingEditor
    },
    toggleFullEditor() {
      this.isFullEditor = !this.isFullEditor
    },
    submitText() {
      this.transcripts = [...this.transcripts, this.textField]
      this.runCode()
    },
    patch() {
      window.__BRYTHON__.builtins.print = (...args) => {
        console.log(`[Python] ${args.join('\n')}`)
        this.logs = [...this.logs, { text: args.join('\n'), type: 'info' }]
      }
    },
    runCode() {
      try {
        this.patch()
        run(this.code)
      } catch (error) {
        window.error = error
        console.warn('User Code Error!', error.message)

        if (error.$py_error) {
          this.logs = [
            ...this.logs,
            {
              text:
                `${error.args[0]}` +
                (error.lineno ? `at line ${error.lineno}` : ''),
              type: 'error'
            }
          ]
        }
      }
    }
  },

  computed: {
    backdropStyle() {
      return {
        background: this.color
      }
    },

    displayPanelClass() {
      return {
        'is-full-width': !this.isShowingEditor
      }
    },

    editorPanelClass() {
      return {
        'is-full-width': this.isFullEditor
      }
    },

    microphoneClass() {
      return {
        'is-listening': this.isListening
      }
    },

    youtubeSrc() {
      return `https://www.youtube.com/embed/${this.youtubeId}?autoplay=1&showinfo=0&controls=0`
    },

    lastText() {
      return this.transcripts[this.transcripts.length - 1]
    }
  }
})
